class Storage {
  constructor() {
    this.store = localStorage;
  }

  getItem(key) {
    try {
      return JSON.parse(this.store.getItem(key));
    } catch (e) {
      return null;
    }

  }

  setItem(key, value) {
    this.store.setItem(key, JSON.stringify(value));
  }

  removeItem(key) {
    this.store.removeItem(key);
  }
}

export default new Storage();



// WEBPACK FOOTER //
// ./src/lib/storage.js